
import {getProp, CanBeSignal} from '@gongxigames/framework/core/fragments/BuilderY';
import {Store, ComputedSignal} from '@gongxigames/framework/core/fragments/store/Store';
import {slotStore} from '@gongxigames/framework/slotV2/globals';

export function computedFormat(amount: CanBeSignal<number>): ComputedSignal<string> {
    return Store.computed(() => slotStore.currencyFormatter.value!.format(getProp(amount)));
}

export function computedFormatCents(amount: CanBeSignal<number>): ComputedSignal<string> {
    return Store.computed(() => slotStore.currencyFormatter.value!.formatCents(getProp(amount)));
}

export function computedFormatNumber(amount: CanBeSignal<number>): ComputedSignal<string> {
    return Store.computed(() => slotStore.currencyFormatter.value!.formatNumber(getProp(amount)));
}

export function computedFormatShort(amount: CanBeSignal<number>, totalBet: CanBeSignal<number>): ComputedSignal<string> {
    return Store.computed(() => slotStore.currencyFormatter.value!.formatShort(getProp(amount), getProp(totalBet)));
}